import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/auth/user.model';
import { FormGroup, FormControl } from '@angular/forms';
import { PageEvent } from '@angular/material/paginator';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { DataService } from 'src/app/shared/data.service';
import { UtilsService } from 'src/app/shared/utils.service';
import { MatDialog } from '@angular/material/dialog';
import { InviteManufacturerComponent } from './invite-manufacturer/invite-manufacturer.component';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { ExportService } from '../../shared/export.service';

@Component({
    selector: 'app-review-invitations',
    templateUrl: './review-invitations.component.html',
    styleUrls: ['./review-invitations.component.scss'],
    standalone: false
})
export class ReviewInvitationsComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  invitationsList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
  };

  searchValue = "";
  user: User;

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private router: Router,
            private exportService: ExportService) {
                this.showSearch = false;
                this.user = this.authService.getUserData();
                this.userID = this.user.id;
                this.route.queryParams.subscribe((params: Params) => {
                  if (!this.isEmpty(params)) {
                    this.pageNumber = params.pageNumber ? params.pageNumber : 1;
                    this.pageSize = params.pageSize ? params.pageSize : 10;
                    this.searchValue =  params.searchValue ? params.searchValue : "";
                  }
                  this.getInvitations();
                });
                }

  ngOnInit(): void {
    this.utils.setTitle('Review Invitations');
    this.utils.screenTitle.emit({firstTitle: 'Review Invitations', firstRoute: '/review-invitations'});
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }

    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
    this.router.navigate(['/review-invitations'], { queryParams: this.queryParams });
  }

  handleSearchClick() {
    if (this.showSearch) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
      this.router.navigate(['/review-invitations'], { queryParams: this.queryParams });
    }
  }

  inviteManufaturer() {
      const dialogRef = this.dialog.open(InviteManufacturerComponent, {
        disableClose: true,
        width: '600px',
        data: {
          type: 'invite',
        }
      });

      dialogRef.afterClosed().subscribe((response) => {
       if(response && response.name) {
         this.getInvitations();
       }
      });
  }

  resendInvitation(manufacturer: any) {
    const payload = {
      name: manufacturer.manufacturerContactName,
      email: manufacturer.email,
      phone: manufacturer.phone,
    };
    this.dataService.post('ManufacturerInvitation/ResendManufacturerInvitation', payload).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Invitation resent successfully',
            buttonText: 'Ok'
          }
        });
      } else if (data.statusCode === 622) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Warning',
            type: 'Warn',
            message: 'Invitation already sent!',
            buttonText: 'Ok',
            closeDialogRef: true
          }
        });
      }  else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue
    };
    this.router.navigate(['/review-invitations'], { queryParams: this.queryParams });
  }

  getInvitations() {
      this.dataService.get('ManufacturerInvitation/RetrieveManufacturerInvitations?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue).then((data: any) => {
        if (data.statusCode === 200) {
          this.invitationsList = [];
          const invitationsData = data.data.records;
          this.totalSize = data.data.count;
          invitationsData.forEach((invitationData: any) => {
            this.invitationsList.push(invitationData);
          });
          if (invitationsData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize, searchValue: this.searchValue};
            this.router.navigate(['/review-invitations'], { queryParams: this.queryParams });
          }
        }
      });
  }

  exportReviewInvitations(fileTypeId: number) {
    this.exportService.exportFile(`ManufacturerInvitation/export/ManufacturerInvitations`, fileTypeId, this.searchValue, 'ReviewInvitations');
  }
}
